import { apiClient } from '../client';
import type { Paginated } from './types';
import type { OwnerType } from '@never2busy/shared';

export type AuditAction =
  | 'LOGIN_OK'
  | 'LOGIN_FAIL'
  | 'LOGOUT'
  | 'PASSWORD_CHANGE'
  | 'CREATE'
  | 'UPDATE'
  | 'DELETE'
  | 'EXPORT';

export interface AuditLog {
  id: number;
  timestamp: string;
  userId: number | null;
  action: AuditAction;
  ownerType: OwnerType | null;
  ownerId: number | null;
  ip: string | null;
  userAgent: string | null;
  message: string | null;
  user: { id: number; firstName: string; lastName: string; email: string } | null;
}

export interface AuditQuery {
  page?: number;
  pageSize?: number;
  userId?: number;
  action?: AuditAction;
  ownerType?: OwnerType;
  from?: string;
  to?: string;
}

export const auditApi = {
  async list(q: AuditQuery): Promise<Paginated<AuditLog>> {
    const { data } = await apiClient.get<Paginated<AuditLog>>('/audit', { params: q });
    return data;
  },
};
